import React from 'react';
import { firstResults, growthSteps } from '../data/kit';
export function FirstThousandSection() {
  return <section className="w-full bg-surface py-20 lg:py-28" aria-labelledby="primeros-1000" data-id="element-141" data-mp="2y1iza9qm4k7y">
      <div className="mx-auto max-w-5xl px-5" data-id="element-142" data-mp="2j62zdo3cpu3n">
        <h2 id="primeros-1000" className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" data-id="element-143" data-mp="2j7e5huk9rdxx">
          ¿Y esos primeros USD 1.000?
        </h2>
        <div className="mt-6 max-w-2xl space-y-2 text-lg text-muted" data-id="element-144" data-mp="2ac7u8g28c3o0">
          <p data-id="element-145" data-mp="2f481ktkmpyum">No podemos prometerte que vas a ganar USD 1.000. Nadie serio debería hacerlo.</p>
          <p data-id="element-146" data-mp="20f2172a222l5">Pero cualquier objetivo económico empieza mucho antes del número. Empieza cuando conseguís:</p>
        </div>

        <ol className="mt-10 grid gap-4 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:items-center" data-id="element-147" data-mp="25ey8pbhyoc5g">
          {firstResults.map((result, i) => <React.Fragment key={result} data-id="element-148" data-mp="1rg8attnbi8g1" data-mpi={i}>
              <li className="rounded-2xl border border-line bg-paper p-5 text-center" data-id="element-149" data-mp="1vg8rzm1swxqs">
                <p className="font-display text-xl font-black text-ink" data-id="element-150" data-mp="27zade3q08n1q">{result}</p>
              </li>
              {i < firstResults.length - 1 && <li aria-hidden="true" className="text-center text-sm font-semibold text-muted" data-id="element-151" data-mp="2307fr4cctj3s">
                  o
                </li>}
            </React.Fragment>)}
        </ol>

        <ol className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-lg text-muted" data-id="element-152" data-mp="2czevtzah3rul">
          {growthSteps.map((step, i) => <li key={step} className="flex items-center gap-6" data-id="element-153" data-mp="1ka7s8lw5wc2h" data-mpi={i}>
              <span className={i === growthSteps.length - 1 ? 'font-semibold text-ink' : ''} data-id="element-154" data-mp="1k7v57ubjrbik">{step}</span>
              {i < growthSteps.length - 1 && <span aria-hidden="true" className="h-px w-6 bg-line" data-id="element-155" data-mp="1u7m03x40rsj6" />}
            </li>)}
        </ol>

        <div className="mt-14 rounded-3xl bg-brand-soft p-8 sm:p-12" data-id="element-156" data-mp="16hrmhdbvlzxv">
          <p className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-157" data-mp="11jhrb2q5izc9">
            Tus primeros USD 1.000 no empiezan en USD 1.000.
          </p>
          <p className="mt-3 font-display text-3xl font-black leading-tight text-brand sm:text-4xl" data-id="element-158" data-mp="1r7dhmev2kcle">
            Empiezan en tu primer resultado real.
          </p>
        </div>
      </div>
    </section>;
}